//所有有关用户信息的网络请求
import http from '../utils/http'

//根据ID查询
export function apiCheckId(id){
    return http({
      url:`/client/buyOrder/unlimited/${id}`,
      method:'get',
    })
}


//提交即新增
export function apiAddAutoLoginList(data){
    return http({
      url:'/client/buyOrder/unlimited',
      method:'post',
      data
    })
  }
  
